import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const url = cfg.url || "";
    if (err.response?.status === 401 && !cfg._retry && url.startsWith("/admin")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
        window.dispatchEvent(new Event("auth-expired"));
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => `${(x.loc || []).slice(-1)[0] || ""}: ${x.msg}`.replace(/^: /, "")).join(" · ");
  return d.msg || String(d);
}

export const img = (u) => (!u ? "" : u.startsWith("/api") ? BACKEND + u : u);

export const money = (minor, cur = "INR") =>
  minor == null ? "" : new Intl.NumberFormat("en-IN", { style: "currency", currency: cur || "INR", maximumFractionDigits: 0 }).format(minor / 100);

export const fmtDate = (d) =>
  d ? new Date(d.length === 10 ? d + "T00:00:00" : d).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : "";

export const label = (s) => (s || "").replace(/[_-]/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export const CATEGORIES = [
  { key: "trek", label: "Trek", path: "/trek", detail: "/trek" },
  { key: "tours", label: "Tours", path: "/tours", detail: "/tours" },
  { key: "heritage-walks", label: "Heritage Walks", path: "/heritage-walks", detail: "/heritage-walk" },
  { key: "camping", label: "Camping", path: "/camping", detail: "/camping" },
  { key: "corporate-trek", label: "Corporate Trek", path: "/corporate-trek", detail: "/corporate-trek" },
];
export const catBy = (k) => CATEGORIES.find((c) => c.key === k) || CATEGORIES[0];
export const expUrl = (e) => `${catBy(e.category).detail}/${e.slug}`;

export async function downloadCsv(path, params = {}) {
  const r = await api.get(path, { params, responseType: "blob" });
  const name = (r.headers["content-disposition"] || "").split("filename=")[1] || "export.csv";
  const a = document.createElement("a");
  a.href = URL.createObjectURL(r.data);
  a.download = name;
  a.click();
  URL.revokeObjectURL(a.href);
}

export function utm() {
  const p = new URLSearchParams(window.location.search);
  const stored = JSON.parse(sessionStorage.getItem("utm") || "{}");
  const cur = { utm_source: p.get("utm_source"), utm_medium: p.get("utm_medium"), utm_campaign: p.get("utm_campaign") };
  const merged = cur.utm_source ? cur : stored;
  if (cur.utm_source) sessionStorage.setItem("utm", JSON.stringify(cur));
  return { utm_source: merged.utm_source || "", utm_medium: merged.utm_medium || "", utm_campaign: merged.utm_campaign || "" };
}

export const waLink = (number, text) => `https://wa.me/${(number || "").replace(/\D/g, "")}?text=${encodeURIComponent(text || "")}`;
